module.exports = __webpack_public_path__ + "img/2_1-industriale-fabbrica_a-2.02454bed.png";